import type { LoginResponse, SessionResponse, ApiSuccessResponse } from "@buflow/contracts";
import { apiRequest } from "./client";

export const authApi = {
  login(username: string, password: string): Promise<LoginResponse> {
    return apiRequest<ApiSuccessResponse<LoginResponse>>("/api/auth/login", {
      method: "POST",
      body: { username, password },
    }).then((res) => res.data);
  },

  logout(): Promise<void> {
    return apiRequest("/api/auth/logout", { method: "POST" });
  },

  getSession(): Promise<SessionResponse> {
    return apiRequest<ApiSuccessResponse<SessionResponse>>("/api/auth/session").then(
      (res) => res.data,
    );
  },
};
